import debounce from '~/utils/events/debounce';
import {setLoading} from '../Store/creators/common';
import {setFilter} from '../Store/creators/filter';
import {setOverview} from '../Store/creators/visualData';
import {dispatch} from '../Store/index';
import {StateVisualOverview} from '../Store/State';
import sendVisualRequest from '../utils/sendVisualRequest';

// tslint:disable:max-line-length
const data = {
	front: {
		view: 'front',
		nextView: 'back',
		image: '/images/choose-visual/overview/01.jpg',
		map: [
			{
				path: 'M655.76 905.32a3.11 3.11 0 0 1-3.23.6l-18.85-8.48c-1-.45-2.46-.18-3.23.6l-9.06 9.16a2.97 2.97 0 0 1-3.2.54l-100.41-49a6.75 6.75 0 0 1-2.67-2.68l-48.51-100.4c-.48-.99-.99-2.69-1.14-3.78l-21.09-155.99a2.37 2.37 0 0 1 1.66-2.52l108.94-30.3a2.96 2.96 0 0 1 3.04 1.13l17.28 25.92a8.53 8.53 0 0 1 1.21 3.66l.54 10.25c.06 1.1.93 2.35 1.94 2.79l85.41 36.83a3.31 3.31 0 0 1 1.84 2.79v1.33c0 1.1.8 2.42 1.77 2.93l12.37 6.45a3.6 3.6 0 0 1 1.76 2.92l-.02 4.54a5.52 5.52 0 0 1-1.44 3.4l-2.26 2.21a4.65 4.65 0 0 0-1.22 3.39l19.83 187.77a4.75 4.75 0 0 1-1.2 3.41l-40.06 40.53z',
				target: '9',
				available: 1,
			},
			{
				path: 'M584.63 607.39c.16 1.09-.54 1.62-1.55 1.19l-4.1-1.76a3.54 3.54 0 0 1-1.95-2.79l-.6-10.5a8.93 8.93 0 0 0-1.2-3.68l-16.83-25.98a2.9 2.9 0 0 0-3.01-1.14l-109.36 30.63a2.37 2.37 0 0 0-1.66 2.52l21.09 155.99a1.69 1.69 0 0 1-1.73 1.97l-121.92-.48c-1.1 0-2.22-.88-2.49-1.95l-2.03-8.12a2.7 2.7 0 0 0-2.49-1.94h-10.33c-1.1 0-2.22-.87-2.48-1.94l-68.78-275.37c-.27-1.07-.2-2.33.14-2.82.34-.48.47-1.76.28-2.85l-1.57-9.06a7.5 7.5 0 0 1 .5-3.78l3.56-7.63c.47-1 1.25-2.62 1.75-3.6l23.45-46.56c.49-.98 1.8-1.8 2.9-1.81l32.08-.44c1.1-.02 2.17-.87 2.37-1.9a2.5 2.5 0 0 1 2.37-1.88l16.25-.04c1.1 0 2.13.89 2.28 1.98l.94 6.7a2.4 2.4 0 0 0 2.28 2l75.17.8c1.1.01 2.87-.2 3.94-.48l16.79-4.33a13.03 13.03 0 0 0 3.57-1.65l28.23-19.86c.9-.63 2.47-.82 3.49-.41l78.29 31.35a3.86 3.86 0 0 1 2.15 2.72l30.21 206.9z',
				target: '8',
				available: 1,
			},
			{
				path: 'M767.15 608.71a2.6 2.6 0 0 1-1.75 2.57l-45 13.52a2.88 2.88 0 0 0-1.92 2.58v2.33a2.9 2.9 0 0 1-1.91 2.6l-37.68 11.8a3.28 3.28 0 0 1-3.21-.92l-1.3-1.51a2.4 2.4 0 0 0-3-.45l-3.45 2.16c-.93.58-2.52.71-3.53.27l-77.64-33.5a4 4 0 0 1-2.13-2.77l-30.19-206.88a3.84 3.84 0 0 0-2.15-2.72l-45.41-18.19c-1.02-.41-1.12-1.26-.22-1.89l32.68-22.94c.9-.63 2.48-.83 3.51-.44l3.14 1.2c1.03.39 2.58.16 3.44-.52l6.1-4.78c.87-.68 2.44-1.47 3.5-1.77l127.02-35.3a3.02 3.02 0 0 1 3.06 1.11l.74 1.08c.62.91 2 1.42 3.07 1.15l15-3.87c1.07-.28 2.5.2 3.19 1.06l34.36 42.57a7.66 7.66 0 0 1 1.42 3.55l20.26 248.9z',
				target: '7',
				available: 1,
			},
			{
				path: 'M949.87 606.95a2.03 2.03 0 0 1-1.98 2.04l-19.35.4c-1.1.02-2 .91-2 1.98 0 1.07-.9 1.94-2 1.93l-61.63-.12c-1.1 0-2 .74-1.99 1.65.01.91-.89 1.64-1.99 1.63l-42.08-.57a2.22 2.22 0 0 1-2.15-2.02l-.57-7.35a2.19 2.19 0 0 0-2.15-1.99H791.4c-1.1 0-2.05-.9-2.12-2l-1.17-19.17a2.15 2.15 0 0 0-2.12-1.99l-19.03.06a2.2 2.2 0 0 1-2.16-1.99L746.89 359.8a7.66 7.66 0 0 0-1.42-3.55l-34.36-42.57a7.29 7.29 0 0 1-1.37-3.55l-2.48-44.09a2.59 2.59 0 0 1 1.82-2.52l34.97-9.46c1.06-.29 2.83-.51 3.93-.49l196 3.1c1.1.02 2.01.93 2.02 2.03l3.87 348.25z',
				target: '6',
				available: 1,
			},
			{
				path: 'M1112.73 627.5a2.36 2.36 0 0 1-2.12 2.14l-2.55.18a2.21 2.21 0 0 0-2.02 2.14l-.03 2.42a2.2 2.2 0 0 1-2.02 2.13l-.51.03a2.37 2.37 0 0 0-2.14 2.12l-.14 1.97a3.04 3.04 0 0 1-2.07 2.53l-4.23 1.18a2.96 2.96 0 0 1-3.04-1.13l-10.03-15.05c-.61-.92-2-1.51-3.08-1.32l-28.69 5.06a2.38 2.38 0 0 0-1.9 2.35l.37 11.38a2.45 2.45 0 0 1-1.9 2.39l-19.28 3.81a3.84 3.84 0 0 1-3.28-1.12l-11.53-13.16a10.56 10.56 0 0 0-3.15-2.31l-57.67-25.47a3.37 3.37 0 0 1-1.85-2.81L946 258.7a53 53 0 0 1 .14-3.99l3.68-44.72a2.39 2.39 0 0 1 2.16-2.12l15.01-.99c1.1-.07 2-.98 2-2.01s.89-2.02 1.97-2.2l82.72-13.48c1.09-.18 2.5.41 3.15 1.3l.31.43a3.27 3.27 0 0 0 3.12 1.16l14.61-3.42a5.79 5.79 0 0 1 3.68.55l57.54 33.33c.95.55 1.67 1.9 1.61 3l-24.97 401.96z',
				target: '5',
				available: 1,
			},
			{
				path: 'M1283.4 210.55c.55.95.9 2.63.78 3.73l-30.67 291.27c-.12 1.09-.53 1.15-.91.12l-6.68-17.84a1.9 1.9 0 0 0-2.54-1.09l-2.36 1.01a3.38 3.38 0 0 0-1.88 2.79l-.37 16.08a3.4 3.4 0 0 1-1.89 2.78l-9.06 3.82a3.11 3.11 0 0 0-1.76 2.78l.46 11a3.26 3.26 0 0 1-1.73 2.85l-33.34 15.67c-1 .47-2.55.34-3.46-.28l-2.53-1.74a3.5 3.5 0 0 0-3.38-.14l-41.03 23.51c-.95.55-2.37.36-3.15-.42l-2-2a3.13 3.13 0 0 0-3.24-.6l-14.58 6.51c-1 .45-1.77-.08-1.7-1.18l21.31-343.65a3.52 3.52 0 0 0-1.61-2.99l-10.9-6.27c-.95-.55-.9-1.35.11-1.78l94.68-40.01c1.01-.43 2.74-.84 3.84-.91l35.09-2.24c1.1-.07 2.44.65 2.99 1.61l21.51 37.61z',
				target: '4',
				available: 1,
			},
			{
				path: 'M1488.85 217.32c1.08.21 1.61 1.2 1.18 2.22l-3.34 7.82a21.1 21.1 0 0 0-1.13 3.81l-48.24 280.72a1.88 1.88 0 0 1-2.29 1.52l-55.1-12.84a20.97 20.97 0 0 0-3.95-.45l-27.66.07c-1.1 0-2.29.86-2.63 1.9l-.57 1.71a3.16 3.16 0 0 1-2.63 2l-36.17 1.95a3.44 3.44 0 0 1-2.94-1.66l-.79-1.47a3.25 3.25 0 0 0-2.93-1.57l-44.35 4.28c-1.09.11-1.9-.7-1.78-1.8l30.67-291.27a2.47 2.47 0 0 1 2.2-2.12l109.59-7.4c1.1-.07 2.88.02 3.96.22l9.94 1.79c1.08.2 2.38-.45 2.88-1.42l.29-.57c.5-.98 1.8-1.61 2.88-1.4l72.91 13.96z',
				target: '3',
				available: 1,
			},
			{
				path: 'M1719.02 198.2c.67.46.99 1.71.72 2.78l-51.44 205.74c-.27 1.07-.98 1.19-1.59.28l-32.28-48.46a3.78 3.78 0 0 0-3.1-1.51l-89.3 6.98a2.86 2.86 0 0 0-2.41 2.11l-38.87 181.8c-.23 1.08-.9 1.2-1.49.27l-13.69-21.54a5.64 5.64 0 0 0-3.02-2.14l-43.6-10.17a2.15 2.15 0 0 1-1.61-2.43l48.24-280.72c.19-1.08.69-2.8 1.13-3.81l4.97-11.57 1.58-3.68 7.49-17.46 1.58-3.68.47-1.1a2.63 2.63 0 0 1 2.76-1.48l37.64 6.79c1.08.2 2.87.3 3.96.24l13.51-.77c1.1-.06 2.81-.51 3.8-.98l41.98-20.26a3.7 3.7 0 0 0 1.89-2.87l.15-3.5c.05-1.1.89-2.42 1.86-2.93l9.21-4.82a4.35 4.35 0 0 1 3.55-.01l1.62.83c.98.5 2.58.52 3.57.03l14.59-7.22a4.75 4.75 0 0 1 3.61-.05l71.95 33.32c1 .46 1.61 1.72 1.36 2.79l-1.51 6.44c-.29 1.05.05 2.3.72 2.76z',
				target: '2',
				available: 1,
			},
			{
				path: 'M1669.37 410.95c.61.92.89 2.54.63 3.6l-17.28 69.37-.98 3.88-47.51 186.62a2.14 2.14 0 0 1-2.45 1.55l-14.49-2.89a2.13 2.13 0 0 0-2.45 1.55l-1.78 7.12a2.12 2.12 0 0 1-2.45 1.54l-61.16-12.37a1.89 1.89 0 0 1-1.47-2.33l2.35-9.21a2.2 2.2 0 0 0-1.4-2.58l-4.23-1.43a2.42 2.42 0 0 1-1.56-2.61l.4-2.39a2.08 2.08 0 0 0-1.63-2.36l-2.87-.56a1.96 1.96 0 0 1-1.54-2.34l11.52-53.73a6.81 6.81 0 0 0-.45-3.76l-17.36-35.96a6.81 6.81 0 0 1-.45-3.76l38.87-181.8a2.84 2.84 0 0 1 2.41-2.11l89.3-6.98c1.1-.09 2.49.59 3.1 1.51l34.93 52.43z',
				target: '1',
				available: 1,
			},
		],
	},
	back: {
		view: 'back',
		nextView: 'front',
		image: '/images/choose-visual/overview/02.jpg',
		map: [
			{
				path: 'M603.73 373.51l-21.34 19.04 2.46-10.67-43.12-6.62-16.25 13.25-22.38-3.38-27.79-17.91-4.33-38.5 71.62-22.34 3.76 2.79 16.74-5.41 38 22.87z',
				target: '1',
				available: 1,
			},
			{
				path: 'M469.83 363.16l-88.85 28.72 27.66 254.17-17.83-8.67-16.58 2.63-9.63 2.37-36.75 3.38-25.37.87-2-6.87-19.88 2.25-1.87-15-8.75.87-55-276.8-1-20.36 10.5-38 30-.67.5 14 90.62-6.17 18-5.87 20.5-15.13 81.88 12.13 5 37.71 4.33 38.5z',
				target: '2',
				available: 1,
			},
			{
				path: 'M614.14 722.05l-17.79-4.04-5.62 3.75-126.25-27.21-55.84-48.5-27.66-254.17 88.85-28.72 5.48 4.06 27.79 17.91 22.38 3.38 16.25-13.25 43.12 6.62-2.46 10.67z',
				target: '3',
				available: 1,
			},
			{
				path: 'M846.85 708.88l-195.12 22.13-16-5.13-.13-19.19-21.46 15.36-31.75-329.5 40.59-36.04 3.25-2.88 54.12-4.25v-11.16l47.94-3.32.94 10.23 70-3.75.16 3.09 24.59-1.09 12.25 39z',
				target: '4',
				available: 1,
			},
			{
				path: 'M1018.23 357.88l-46.5 35.38-2.25 329.37-16.34-3.16-.33 1.58-87.65-6.92.03-4.45-10.46-.63-7.88-.17-10.62-326.5-12.25-39-.67-50 13.33-6.16.17-11.17 21.54-9.42 15 4.75 12.75-4.75 7-13.25 10.25.5 1.49-3.96h8.45l.56-2.54 54.98 3.24v2.79h6.57l-.17 5.22h8.45l.05 18.13 34.62 28.62z',
				target: '5',
				available: 1,
			},
			{
				path: 'M1213.73 439.63l-20.63 308.75-26.75.13-1.85 31.12h-15.02l-180-57 2.25-329.37 46.5-35.38 21.75 4 3.75-3.72 56.12 12.97 11.5-9.5 44.75 10.47v11.16l47.63 12.25z',
				target: '6',
				available: 1,
			},
			{
				path: 'M1491.34 474.29l-33.36 273.59-90.25 37.75-153.5-1.12-.04-4.42-22.09-.83 1-30.88 20.63-298.75 45.08-.25.36-15.56 50.47-.44 4.17 16h40.17l50.83-16.16 79.01 41.07z',
				target: '7',
				available: 1,
			},
			{
				path: 'M1639.64 707.72l-5.66 11.66-7-1.5-1.5 18.5-7.36 16.43-2.48 2.41-5.66-1.5-4.5 14.16-24.17-7.66-5 8.83-89.41-25.71-16.17-.33-12.75 4.87 33.36-273.59h-7.52l-79.01-41.07 4.83-36.17 21.84-5.17 1.5-13.66 5.66-2.34 4-17 99.34.17 11.66 19 14.17 8.33 92.68 19.17 1.15-6.17 5-8.5 31.34 7.17z',
				target: '8',
				available: 1,
			},
			{
				path: 'M1432.98 378.22l-1.5 13.66-21.84 5.17-4.83 36.17-50.83 16.16-13.17.34 5.33-70.17 59.34-16.67 13.5 8.25 5.75-2.5 13.91 7.25z',
				target: '9',
				available: 1,
			},
		],
	},
};

async function fetchVisualOverview( view: string ): Promise<void>
{
	dispatch( setLoading( true ) );
	
	const serverData = await sendVisualRequest( {overviewView: view} );
	
	if ( !( view in data ) )
	{
		view = 'front';
	}
	
	const viewData = {...(data as any)[view]} as StateVisualOverview;
	
	if ( serverData.overview && serverData.overview.map )
	{
		const sections = new Map<string | number, number>();
		
		for ( const item of serverData.overview.map )
		{
			sections.set( item.target, item.available );
		}
		
		for ( const item of viewData.map )
		{
			if ( sections.has( item.target ) )
			{
				// tslint:disable-next-line:no-non-null-assertion
				item.available = sections.get( item.target )!;
			}
			else
			{
				item.available = 0;
			}
		}
	}
	
	// TODO:
	dispatch(
		setFilter( serverData.filter ),
	);
	
	dispatch( setOverview( viewData ) );
	
	dispatch( setLoading( false ) );
}

const debouncedFetchVisualOverview = debounce( fetchVisualOverview, 200 );

/**
 * Module.
 */
export {
	fetchVisualOverview as default,
	debouncedFetchVisualOverview,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/asyncActions/fetchVisualOverview.ts